var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightDecorator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 97,
    viewBox: "0 0 97 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M52.3509 75.563C37.2614 77.8177 23.2124 67.44 20.8999 52.3794C18.6451 37.3187 28.9939 23.212 44.0545 20.9283C59.1441 18.6157 73.2219 28.9935 75.5056 44.1119C77.7892 59.1726 67.4405 73.2504 52.3509 75.563Z",
    fill: "url(#paint0_radial_3470_3360)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M40.2966 60.9942L48.4774 49.9516L59.5488 58.0168C63.6247 60.9364 67.6429 63.8849 71.7477 66.7178C79.8995 72.5281 88.0802 78.194 96.4344 83.7152C88.7162 77.3846 80.8534 71.2274 72.9039 65.1569C68.9437 62.1216 64.9545 59.1442 60.9942 56.1378L49.9806 47.957L58.0456 36.8567C60.9364 32.8097 63.856 28.7915 66.7467 24.7156C72.4703 16.5349 78.194 8.35418 83.7153 0C77.3557 7.71822 71.2273 15.6099 65.1568 23.5305C62.0927 27.4908 59.1441 31.5089 56.1089 35.4403L47.957 46.4827L36.8856 38.3888C32.8386 35.498 28.7338 32.5495 24.6868 29.6588C16.5349 23.8774 8.38309 18.1826 0 12.7192C7.71822 19.0498 15.6099 25.1782 23.5015 31.2487C27.4329 34.3417 31.451 37.2903 35.4402 40.3256L46.4539 48.4773L38.3888 59.5489C35.4691 63.5959 32.5495 67.6428 29.6877 71.7188C23.9062 79.8417 18.2404 88.0513 12.7481 96.3766C19.0787 88.6584 25.236 80.7956 31.2776 72.875C34.3128 68.9147 37.2903 64.9545 40.2966 60.9653V60.9942Z",
    fill: "url(#paint1_radial_3470_3360)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M39.4583 60.1264C32.8963 55.27 31.5088 46.0486 36.3363 39.4578C41.1638 32.9248 50.4141 31.5084 56.976 36.3359C63.538 41.1634 64.9255 50.4136 60.098 56.9756C55.2705 63.5375 46.0491 64.9251 39.4583 60.0976V60.1264Z",
    fill: "url(#paint2_radial_3470_3360)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M40.4122 50.0674L47.6679 48.9978L48.7953 56.2246C49.2289 58.8841 49.6336 61.5146 50.0961 64.1163C50.9922 69.3774 51.9462 74.6385 53.0157 79.8707C52.4954 74.5518 51.8594 69.2618 51.1368 63.9718C50.7899 61.3123 50.3852 58.6818 50.0383 56.0512L48.9687 48.7955L56.1955 47.6392C58.8261 47.2056 61.4566 46.8009 64.0872 46.3383C69.3483 45.4133 74.5805 44.4883 79.8416 43.4187C74.5227 43.939 69.2327 44.604 63.9427 45.2977C61.2832 45.6446 58.6526 46.0204 55.9932 46.3673L48.7375 47.4658L47.6101 40.239C47.1765 37.6084 46.7429 34.9489 46.2803 32.3183C45.3842 27.0572 44.4592 21.7962 43.3607 16.564C43.8811 21.8829 44.5459 27.1729 45.2397 32.4629C45.5577 35.1224 45.9624 37.7529 46.3382 40.4124L47.4077 47.6681L40.1809 48.8244C37.5504 49.258 34.9198 49.6627 32.2893 50.1252C27.0282 51.0213 21.796 51.9753 16.5638 53.0448C21.8827 52.5245 27.1727 51.8886 32.4627 51.1659C35.0933 50.819 37.7238 50.4432 40.3833 50.0674H40.4122Z",
    fill: "url(#paint3_radial_3470_3360)"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3470_3360",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.9843 48.1517) rotate(126.335) scale(26.2508 26.2437)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD495"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3470_3360",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.8295 48.0373) rotate(126.369) scale(45.7988 45.8031)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD495"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_3470_3360",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.0985 48.1747) rotate(126.36) scale(14.02)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD495"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_3470_3360",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.9483 48.1181) rotate(126.34) scale(30.0726 30.066)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD495"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightDecorator);
export default __webpack_public_path__ + "static/media/lightDecorator.e068f2cd42e8adf69f9f150ad049d588.svg";
export { ForwardRef as ReactComponent };